import axios from "axios";
import getConfigByName from "../../../config";

const verificationAxios = axios.create();

verificationAxios.interceptors.request.use(
    (config) => {
        if (!config.baseURL) {
            let url = localStorage.getItem("verificationURL");
            if (!url || url === "undefined" || url === "null") {
                 const appConfig = getConfigByName();
                 url = appConfig?.verificationURL;
            }
            if (url) {
                config.baseURL = url;
            }
        }

        const token = localStorage.getItem("a_t");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export async function apiGetUserVerificationFlows(data) {
    const payload = {
        filter: {},
        sort: {},
        limit: 0,
        offset: 0,
        ...data,
    };

    try {
        const response = await verificationAxios.post(`/api/flow/setting/get`, payload);
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiAssignUserVerificationProfile(flowSettingId) {
    try {
        const response = await verificationAxios.post(`/api/user_verification/profile/assign`, flowSettingId, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiGetUserVerificationProfile(data, urlVerification= "") {
    const payload = {
        filter: {},
        sort: {},
        limit: 0,
        offset: 0,
        ...data,
    };

    const config = {};
    if (urlVerification) {
        config.baseURL = urlVerification;
    }

    try {
        const response = await verificationAxios.post(`/api/user_verification/profile/get`, payload, config);
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiGetUserVerificationHistories(data) {
    const payload = {
        filter: {},
        sort: {},
        limit: 0,
        offset: 0,
        ...data,
    };

    try {
        const response = await verificationAxios.post(`/api/user_verification/history/get`, payload);
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiInitializeUserVerificationHistory(tierSettingId) {
    try {
        const response = await verificationAxios.post(`/api/user_verification/history/init`, tierSettingId, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiDuplicateUserVerificationHistory(payload) {
    try {
        const response = await verificationAxios.post(`/api/user_verification/history/duplicate`, payload, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiAbandonUserVerificationProfile() {
    try {
        const response = await verificationAxios.post(`/api/user_verification/profile/abandon`, {}, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiSaveUserVerificationHistory(data) {
    try {
        const response = await verificationAxios.post(`/api/user_verification/history/save`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiSubmitUserVerificationHistory(data) {
    try {
        const response = await verificationAxios.post(`/api/user_verification/history/submit`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiUploadUserVerificationHistoryMedia(formData) {
    try {
        const response = await verificationAxios.post(`/api/user_verification/history/upload`, formData);
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiUpdateUserVerificationHistoryStatus(data) {
    try {
        const response = await verificationAxios.post(`/api/user_verification/history/update_status`, data);
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiGetUserVerificationTiers(data) {
    const payload = {
        filter: {},
        sort: {
            tierLevel: 1
        },
        limit: 0,
        offset: 0,
        ...data,
    };

    try {
        const response = await verificationAxios.post(`/api/tier/setting/get`, payload);
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiDeleteMediaResponse(fileName) {
    try {
        const response = await verificationAxios.delete(`/assets/response/${fileName}`);
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiGetMediaResponse(fileRelativePath) {
    try {
        const path = fileRelativePath.startsWith('/') ? fileRelativePath : `/${fileRelativePath}`;
        const response = await verificationAxios.get(path);
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const apiGetVerificationTierSettingsAccessRights = async () => {
    try {
        const response = await verificationAxios.get(`/api/tier/setting/access_right/list`);
        return response?.data;
    } catch (e) {
        throw e;
    }
}

export async function apiCancelVerificationHistory(id) {
    try {
        const response = await verificationAxios.post(`/api/user_verification/history/cancel`, JSON.stringify(id), {
             headers: {
                "Content-Type": "application/json"
            }
        });
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}
